import { useViewport } from './useViewport';

/**
 * Whether the inline desktop sidebar is currently rendered (viewport at or
 * above the nav breakpoint). Below it there is no sidebar at all — the phone
 * shell's top row and bottom bar own navigation and occupy no layout width, so
 * fixed-position elements must not offset by the sidebar width.
 *
 * A named alias of `useViewport() !== 'phone'`, kept because "is the sidebar
 * there" is what its callers are asking.
 */
export function useHasInlineSidebar(): boolean {
  return useViewport() !== 'phone';
}
